import { render } from "./Show.vue?vue&type=template&id=48aa6210&scoped=true"
import script from "./Show.vue?vue&type=script&lang=js"
export * from "./Show.vue?vue&type=script&lang=js"

import "./Show.vue?vue&type=style&index=0&id=48aa6210&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-48aa6210"

export default script